import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosConfig";
import { DEAL_GRID_COLUMNS, DEFAULT_COLUMNS, REQUIRED_COLUMNS, normalizeColumns } from "../../utils/dealGridColumns";

const GridSettings = () => {
  const navigate = useNavigate();
  const [columns, setColumns] = useState(DEFAULT_COLUMNS);
  const [availableChoiceInput, setAvailableChoice] = useState("");
  const [selectedChoiceInput, setSelectedChoice] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  useEffect(() => {
    axios.get("/newdeal/grid-settings").then(res => setColumns(normalizeColumns(res.data.columns)))
      .catch(() => { setLoadFailed(true); setError("Unable to load grid settings. Reload to try again."); })
      .finally(() => setLoading(false));
  }, []);
  const available = DEAL_GRID_COLUMNS.filter(column => !columns.includes(column.key));
  const availableChoice = available.some(column => column.key === availableChoiceInput)
    ? availableChoiceInput : available[0]?.key || "";
  const selectedChoice = columns.includes(selectedChoiceInput) ? selectedChoiceInput : columns[0] || "";
  const move = offset => {
    const index = columns.indexOf(selectedChoice);
    if (index < 0 || index + offset < 0 || index + offset >= columns.length) return;
    const next = [...columns];
    [next[index], next[index + offset]] = [next[index + offset], next[index]];
    setColumns(next);
    setMessage("");
  };
  const save = async () => {
    setSaving(true); setError(""); setMessage("");
    try { await axios.put("/newdeal/grid-settings", { columns }); setMessage("Grid settings saved. Open Ongoing Deal to see your layout."); }
    catch (err) { setError(err.response?.data?.message || "Unable to save grid settings"); }
    finally { setSaving(false); }
  };
  return <div className="card"><div className="card-header"><h5 className="mb-0">Ongoing Deal — Grid Settings</h5></div>
    <div className="card-body">
      <p>Selected Fields appear in the grid in the order shown. Settings are saved for your user account.</p>
      <p className="text-muted">Sr No, Deal ID and Action must remain selected.</p>
      {error && <div role="alert" className="alert alert-danger">{error}</div>}
      {message && <div role="status" className="alert alert-success">{message}</div>}
      <fieldset disabled={loading || saving || loadFailed}>
        <div className="row g-3 align-items-center">
          <div className="col-md-5"><label htmlFor="available-fields" className="form-label fw-bold">Available Fields</label>
            <select id="available-fields" size="12" className="form-select" value={availableChoice} onChange={e => setAvailableChoice(e.target.value)}>
              {available.map(column => <option key={column.key} value={column.key}>{column.label}</option>)}
            </select></div>
          <div className="col-md-2 d-flex flex-column gap-2">
            <button type="button" className="btn btn-outline-primary" disabled={!availableChoice || columns.includes(availableChoice)} onClick={() => { setColumns([...columns, availableChoice]); setAvailableChoice(""); setMessage(""); }}>Add →</button>
            <button type="button" className="btn btn-outline-primary" disabled={available.length === 0} onClick={() => { setColumns([...columns, ...available.map(column => column.key)]); setAvailableChoice(""); setMessage(""); }}>Add All →→</button>
            <button type="button" className="btn btn-outline-secondary" disabled={!selectedChoice || REQUIRED_COLUMNS.includes(selectedChoice)} onClick={() => { setColumns(columns.filter(key => key !== selectedChoice)); setSelectedChoice(""); setMessage(""); }}>← Remove</button>
            <button type="button" className="btn btn-outline-secondary" onClick={() => { setColumns(columns.filter(key => REQUIRED_COLUMNS.includes(key))); setSelectedChoice(""); setMessage(""); }}>←← Remove All Optional</button>
          </div>
          <div className="col-md-5"><label htmlFor="selected-fields" className="form-label fw-bold">Selected Fields</label>
            <select id="selected-fields" size="12" className="form-select" value={selectedChoice} onChange={e => setSelectedChoice(e.target.value)}>
              {columns.map(key => <option key={key} value={key}>{DEAL_GRID_COLUMNS.find(column => column.key === key).label}</option>)}
            </select>
            <div className="d-flex gap-2 mt-2"><button type="button" className="btn btn-outline-secondary" disabled={columns.indexOf(selectedChoice) <= 0} onClick={() => move(-1)}>↑ Move Up</button>
              <button type="button" className="btn btn-outline-secondary" disabled={!selectedChoice || columns.indexOf(selectedChoice) === columns.length - 1} onClick={() => move(1)}>↓ Move Down</button></div>
          </div>
        </div>
        <div className="d-flex gap-2 mt-4 flex-wrap"><button type="button" className="btn btn-success" onClick={save}>{saving ? "Saving…" : "Save"}</button>
          <button type="button" className="btn btn-secondary" onClick={() => { setColumns([...DEFAULT_COLUMNS]); setSelectedChoice(""); setAvailableChoice(""); setMessage(""); }}>Reset to Default</button>
          <button type="button" className="btn btn-outline-primary" onClick={() => navigate("/transaction/new-deal/list")}>Back to Ongoing Deal</button></div>
      </fieldset>
    </div></div>;
};
export default GridSettings;
